import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20geometric%20shapes%20in%20deep%20red%20crimson%20and%20dark%20orange%20tones%2C%20modern%20editorial%20news%20layout%20style%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20minimalist%20design%20with%20subtle%20texture%20overlay%2C%20clean%20professional%20atmosphere&width=1600&height=900&seq=hero-bg-51bl&orientation=landscape"
          alt="51爆料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <i className="ri-fire-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-semibold text-primary-200 tracking-wide">每日爆料第一站</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-4 font-heading">
              51爆料网 · 全网最快吃瓜爆料平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 mb-4 font-semibold">
              今日最新爆料实时更新，你的吃瓜第一选择
            </p>

            <div className="text-sm md:text-base text-white/65 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-7 space-y-3">
              <p>
                51爆料网汇聚娱乐圈、网红圈、社会热点等九大板块的第一手爆料资讯，
                7×24小时全天候追踪全网最新消息，让你随时随地掌握最热八卦。
              </p>
              <p>
                无论是最新明星恋情、综艺内幕揭秘，还是网红翻车现场、商界大佬恩怨，
                我们都在第一时间为你呈现最真实、最全面的吃瓜内容。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-white font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/55 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all whitespace-nowrap text-sm"
              >
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => handleScroll(e, '#contact')}
                className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all whitespace-nowrap text-sm border border-white/25"
              >
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20stylish%203D%20illustration%20of%20a%20megaphone%20bursting%20with%20colorful%20news%20fragments%20against%20a%20dark%20background%2C%20red%20and%20orange%20accent%20colors%2C%20dynamic%20composition%20with%20floating%20newspaper%20pieces%20and%20speech%20bubbles%2C%20modern%20editorial%20style%2C%20high%20contrast%2C%20bold%20graphic%20design%20aesthetic&width=1000&height=800&seq=hero-visual-51bl&orientation=portrait"
                alt="51爆料网主视觉"
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}